"use client";
// @ts-strict-ignore

import type { ReactNode } from "react";
import { ThemeProvider } from "styled-components";
import lightTheme from "themes/light";

export function StyledComponentsThemeProvider({
  children
}: {
  children: ReactNode;
}) {
  return <ThemeProvider theme={lightTheme}>{children}</ThemeProvider>;
}
